import {AnalyticsEventActions} from '@mintdata-wsp/common/controllers/analytics/AnalyticsEventActions';
import {ApiError} from '@mintdata-wsp/common/controllers/network/Fetcher';
import {Project} from '@mintdata-wsp/common/state/DataState';
import {rootState} from '@mintdata-wsp/common/state/RootState';
import {Dialogs} from '@mintdata-wsp/wsp/controllers/common/DialogsController';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {Column} from '@mintdata-wsp/wsp/ui/components/forms/Column';
import {Form} from '@mintdata-wsp/wsp/ui/components/forms/data/Form';
import {Dialog} from '@mintdata-wsp/wsp/ui/components/forms/Dialog';
import {DialogButton} from '@mintdata-wsp/wsp/ui/components/forms/DialogButton';
import {ErrorPopupSide, Input, InputStyle} from '@mintdata-wsp/wsp/ui/components/forms/Input';
import bind from 'bind-decorator';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./AddSpaceDialog.less');
const cx = classnames.bind(styles);

export class AddSpaceDialogState
{
    spaceName:string = '';
    apiError:ApiError = null;
    isLoading:boolean = false;
}

@observer
export class AddSpaceDialog extends React.Component<any, AddSpaceDialogState>
{
    private _form:Form = new Form();

    constructor(props:any)
    {
        super(props);
        this.state = new AddSpaceDialogState();
    }

    @bind
    _onCreateSpace()
    {
        let {spaceName} = this.state;

        if( !spaceName || spaceName.trim().length == 0 )
        {
            this._validateForm();
            return;
        }

        this.setState({
            apiError: null,
            isLoading: true,
        });

        controllers.data.projects.createProject(spaceName.trim(), 'some desc ' + Math.random())
            .then((newProject:Project) =>
            {
                const {currentOrganization} = rootState.userSession;

                controllers.analytics.main.trackEvent(
                    AnalyticsEventActions.WSP_SPACE_CREATED,
                    {
                        org_sid: currentOrganization.siteId,
                        org_name: currentOrganization.name,

                        space_id: newProject.id,
                        space_name: newProject.name
                    }
                );

                controllers.ui.dialogs.hideDialog(Dialogs.AddSpace);
                controllers.ui.mainPage.selectProject(newProject);
                controllers.navigation.toProject(newProject.id);
            })
            .catch((apiError:ApiError) =>
            {
                this.setState({apiError}, () =>
                {
                    this._validateForm();
                });
            });
    }

    private _validateForm = () =>
    {
        const fields = ['spaceName'];

        this._form.getFields(fields).forEach(field =>
        {
            field.elementRef.checkIsValid();
        });
    };

    @bind
    _onSpaceNameChanged(newValue:string)
    {
        this.setState({spaceName: newValue});
    }

    @bind
    private _handleClose():void
    {
        controllers.ui.dialogs.hideDialog(Dialogs.AddSpace);
    }

    render()
    {
        const {spaceName, apiError, isLoading} = this.state;

        return (
            <Dialog
                title={'New space'}
                onClose={this._handleClose}
            >
                <Column className={cx('contentColumn')}>

                    <Input
                        // label={'Use spaces to group applications in your organization'}
                        // icon={MDIcons.common.Space}
                        placeholder={'Enter space name'}
                        style={InputStyle.Dialog}
                        errorPopupSide={ErrorPopupSide.Bottom}
                        isValidFn={(value:string) =>
                        {
                            return value && value.length > 0 && !apiError;
                        }}
                        getErrorMessageFn={(value:string) =>
                        {
                            return apiError
                                ? apiError.message
                                : `Please enter a name for your space | ( "${value}" was too short )`;
                        }}
                        onChange={this._onSpaceNameChanged}
                        onEnterKey={this._onCreateSpace}
                        isInitiallyFocused={true}
                        formKey={'spaceName'}
                        form={this._form}
                    />

                    <DialogButton
                        caption={'Create space'}
                        onClick={this._onCreateSpace}
                        isDisabled={isLoading || !spaceName || spaceName.trim().length === 0}
                    />

                </Column>
            </Dialog>
        );
    }
}
